import React from "react";
import { css } from "aphrodite";
import { connect } from "react-redux";
import { callApi, validateToken } from "../../../../lib/utils";
import { Nav, Offcanvas } from "react-bootstrap";
import styles from "./style";
import SubMenu from "../SubMenu";

class SideBar extends React.Component {
  constructor(props) {
    super();
    this.state = {
      menus: [],
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps, prevState) {
    //console.log("prevProps...",prevProps)
    if (prevProps.user.roleId !== this.props.user.roleId) this.fetchData();
  }

  fetchData = () => {
    //const { user } = this.props;
    validateToken((err) => {
      if (err) {
        window.location = "/logout";
      }
      this.setState({
        loading: true,
      });
      callApi(`/api/web/patient/menu/list`, {}, "GET")
        .then((response) => {
          let res = response.data.data;
          let menus = [];

          if (!this.props.user.entityMaster.chargeToCustomer) {
            menus = res.filter((val) => {
              return val.menuName !== "Order Management";
            })
          } else
            menus = res;

          this.setState({
            loading: false,
            menus,
          });
        })
        .catch((err) => {
          console.log("err: ", err);
          this.setState({
            loading: false,
          });
        });
    });
  };

  render() {
    return (
      <div>
        <Offcanvas
          show={this.props.isOpen}
          onHide={this.props.toggle}
          style={{ width: "340px" }}
        >
          <Offcanvas.Header
            closeButton
            style={{ backgroundColor: "#d2d2d2", padding: "1rem 2rem" }}
          >
            <Offcanvas.Title>
              <img
                src={"/images/inspyre_logo_new.png"}
                alt="..."
                className={css(styles.logoStyle)}
              />
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body style={{ backgroundColor: "#354052" }}>
            <Nav className="flex-column pt-2">
              {this.state.menus.map((menu, index) =>
                menu.subMenus.length !== 0 ? (
                  <SubMenu
                    key={menu.subMenus.id + "_" + index}
                    title={menu.menuName}
                    icon={menu.iconClass}
                    items={menu.subMenus}
                  />
                ) : (
                  <Nav.Item
                    key={menu.id + "_" + index}
                    className={["active", css(styles.navItemsStyle)]}
                  >
                    <Nav.Link
                      className={[css(styles.navLinkStyle)]}
                      href={menu.path}
                    >
                      <i
                        className={menu.iconClass}
                        style={{ paddingRight: "5px" }}
                      />
                      {menu.menuName}
                    </Nav.Link>
                  </Nav.Item>
                )
              )}
            </Nav>
          </Offcanvas.Body>
        </Offcanvas>

        {/* </div> */}
      </div>
    );
  }
}

//export default SideBar;

export default connect(
  (store) => {
    return {
      user: store.user,
    };
  },
  (dispatch) => {
    return {};
  }
)(SideBar);
